module.exports = __webpack_public_path__ + "static/media/placeholder.95753f14.svg";